import script from "./defaultStyleMain.vue?vue&type=script&lang=ts&setup=true"
export * from "./defaultStyleMain.vue?vue&type=script&lang=ts&setup=true"

import "./defaultStyleMain.vue?vue&type=style&index=0&id=8036c6ae&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8036c6ae"]])

export default __exports__